<div class="row">
    <div class="col-sm-3 customer customerLogo "><span class="customerTitle"></span>
    </div>
    <div class="col-sm-9 backgroundLogin">
      <app-cosy-login [singleLogin]="false" (cosyToken)="cosyTokenChance($event)"></app-cosy-login>
    </div>
</div> 



<ng-container *ngFor="let items of appList; let i = index" >
  <div class="row top-buffer" >
    <div class="col-sm-1">
    </div>
    <div class="col-sm-3" *ngFor="let item of items; let j = index" >
        <div id="card-choice" class="card mb-3 cardText" (dblclick) = "chkMultiClicks()" (click)="choiceApp(item['DisplayName'], item['VariantID'], item['ID']);chkMultiClicks()">
        <img [src]="item['imgurl']" class="{{item['class']}}" alt="{{appServerOwner}}" id="{{item['imgID']}}" >
        <div class="card-img-overlay no-select">
            <h5><span class="card-title">{{item['DisplayName']}}</span></h5>
            <p class="card-text">{{item['Description']}}</p>
        </div>
      </div>
    </div>
    <div class="col-sm-1">
    </div>
  </div>
</ng-container>  